import find from "lodash/find";

export const getPartnerActivityPrices = (
  userCurrency,
  prices,
) => {
  let discountedPrice;
  let regularPrice;

  try {
    discountedPrice = find(prices.discounted_prices,
      priceObject => priceObject.currency === userCurrency,
    ).amount;
  } catch (e) {
    discountedPrice = null;
  }

  try {
    regularPrice = find(prices.regular_prices,
      priceObject => priceObject.currency === userCurrency,
    ).amount;
  } catch (e) {
    regularPrice = null;
  }

  return { discountedPrice, regularPrice };
};



// WEBPACK FOOTER //
// ./assets/shared/utils/getPartnerActivityPrices.js